/**
 * 更方便的接入智齿客户
 *
 * @param {*} param0 配置对象
 */
/**
 * 更方便的接入智齿客户
 *
 * @param {*} param0 配置对象
 */
const HeTaoCustomerService = function ({
    sysNum = 'a4b3b00a1e0d46e593523500ffff41e9',
    partnerId = '',
    // 主题颜色
    color = '2DCA93',
    // 自定义按钮的class
    sClass,
    // 弹窗大小
    size = {
        width: 360,
        height: 550
    },
    // 默认使用自定义的按钮
    customBtn = 'true',
    // 自定义配置
    diy = {},
    // 设置客服接待组id
    groupId = false,
    aid = false,
    // 是否开启拖拽功能
    drag = false,
    // 拖拽偏移量
    dragNum = 5,
    moduleType = 2,
    userInfo = false,
    click = () => {},
    callOnload = () => {}
}) {
    this._isClick = true;
    // 在智齿代码加载完成之后会执行, 参数是智齿抛出的对象
    this.init = () => {};
    // 设置用户信息
    this.setUserInfo = ({
        userId = 0,
        lessonId = 0,
        classId = 0,
        // 班级
        className = '',
        // 班主任
        teacher = ''
    }, info = {}) => {
        info.params = info.params ? JSON.stringify(info.params) : '{}';
        this.z.set('customerFields', JSON.stringify({
            customField2: userId,
            customField3: lessonId,
            customField4: classId,
            customField5: className,
            customField6: teacher
        }));
        this.z.set('userinfo', info);
    };
    // 自定义元素以便于拖拽处理
    const cl = 'hetao-customer-service-btn';
    const btn = document.createElement('div');
    btn.style.display = 'none';
    btn.className = cl;
    document.body.appendChild(btn);
    const script = document.createElement('script');
    script.id = 'zhichiScript';
    script.src = `//www.sobot.com/chat/frame/js/entrance.js?sysNum=${sysNum}`;
    script.setAttribute('class', cl);
    if (partnerId !== '') script.setAttribute('data-args', `partnerId=${partnerId}`);
    document.body.appendChild(script);
    script.onload = () => {
        this.z = (window.getzhiSDKInstance());
        this.z.on('load', () => {
            if (callOnload) {
                callOnload();
            }
            if (userInfo) this.setUserInfo(userInfo.diy, userInfo.default);
            this.z.set('manual', 'true');
            if (aid) {
                // this.z.set('aid', aid);
                this.z.set('transferAction', `[{'actionType': 'to_service','optionId': '2','deciId': '${aid}'}]`);
            } else {
                this.z.set('groupId', groupId);
            }
            this.z.set('moduleType', moduleType);

            this.z.set('tranFlag', 1);
            // 设置主题色
            this.z.set('color', color);
            // 不显示智齿科技的信息
            this.z.set('powered', false);
            // 用自定义的按钮
            this.z.set('customBtn', customBtn);
            this.z.set('customMargin', 10);
            this.z.set('satDegree_A', false);
            this.z.set('isFeedBackFlag', false);
            this.z.set('autoExpand', false);
            // 设置窗口大小
            this.z.set('size', size);
            for (const k in diy) this.z.set(k, diy[k]);
            // 初始化自定义按钮功能
            this.z.initBtnDOM();
            this.init(this.z);
        });
    };
    this.chatFrame = null;
    this.isMoblie = () => document.querySelector('#ZCPanel');
    this.isShowIframe = () => {
        if (this.chatFrame === null) {
            const frame = document.querySelector('#ZCChatFrame');
            if (frame) {
                this.chatFrame = frame;
                if (this.chatFrame.style.display === 'block') return true;
                return false;
            }
            return false;
            
        }
        if (this.chatFrame.style.display === 'block') return true;
        return false;
        
    };

    // 取得自定义的元素
    const el = document.querySelector(sClass);
    if (drag) {
        const now = {};
        const offset = {
            width: el.offsetWidth,
            height: el.offsetHeight
        };
        let w = window.innerWidth;
        let h = window.innerHeight;

        window.addEventListener('resize', () => {
            w = window.innerWidth;
            h = window.innerHeight;
        }, false);

        el.addEventListener('mousedown', e => {
            now.isMouse = true;
            now.x = e.clientX;
            now.px = e.clientX - el.offsetLeft;
            now.y = e.clientY;
            now.py = e.clientY - el.offsetTop;
        }, false);

        el.addEventListener('click', e => {
            e.stopPropagation();
            if (now.isMove) {
                now.isMove = false;
            } else {
                if (this._isClick) {
                    this._isClick = false;
                    click();
                }
                const mm = this.isMoblie();
                if (mm) {
                    if (mm.style.display === 'block') {
                        this.z.collapse();
                    } else if (mm.style.display === 'none') {
                        this.z.expand();
                    }
                } else if (this.isShowIframe()) {
                    this.z.collapse();
                } else {
                    this.z.expand();
                }
            }
        }, false);

        window.addEventListener('mousemove', e => {
            if (now.isMouse) {
                /* eslint-disable max-len */
                if ((e.clientX - now.x) > dragNum || (now.x - dragNum) > e.clientX || (e.clientY - now.y) > dragNum || (now.y - dragNum) > e.clientY) {
                    now.isMove = true;
                    let x = e.clientX - now.px;
                    let y = e.clientY - now.py;
                    // 元素拖拽边缘检测
                    if (x <= 0) x = 0;
                    if (y <= 0) y = 0;
                    if (x >= (w - offset.width)) x = w - offset.width;
                    if (y >= (h - offset.height)) y = h - offset.height;
                    el.style.top = `${y}px`;
                    el.style.left = `${x}px`;
                }
            }
        }, false);

        window.addEventListener('mouseup', () => {
            if (now.isMouse) {
                now.x = null;
                now.px = null;
                now.y = null;
                now.py = null;
                now.isMouse = false;
            }
        }, false);
    } else {
        el.addEventListener('click', e => {
            e.stopPropagation();
            if (this._isClick) {
                this._isClick = false;
                click();
            }
            const mm = this.isMoblie();
            if (mm) {
                if (mm.style.display === 'block') {
                    this.z.collapse();
                } else if (mm.style.display === 'none') {
                    this.z.expand();
                }
            } else if (this.isShowIframe()) {
                this.z.collapse();
            } else {
                this.z.expand();
            }
        }, false);
    }
    window.addEventListener('click', () => {
        if (!this.isMoblie()) {
            if (this.isShowIframe()) {
                this.z.collapse();
            }
        }
    }, false);
};

export default HeTaoCustomerService;
